import React from 'react'
import '../TabsPartner/TabsPartner.css'
import { Container, Row, Col } from 'react-bootstrap'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import PartnersOnline from '../../../images/PartnerOnline.png'
function TabsPartner() {
    return (
        <>
            <section className='partners-tabs'>
                <Container>
                    <Row>
                        <Col sm={12}>
                            <Tabs
                                defaultActiveKey="profile"
                                id="uncontrolled-tab-example"
                                className="mb-3"
                            >
                                <Tab eventKey="home" title={<span><img src={PartnersOnline} alt=''/>Partner Online Empanelment</span>}>

                                </Tab>
                                <Tab eventKey="profile" title={<span><img src={PartnersOnline} alt=''/>Partner Offline Empanelment</span>}>
                                    Tab content for Profile
                                </Tab>
                                <Tab eventKey="contact" title={<span><img src={PartnersOnline} alt=''/>Partner Transaction Platform</span>}>
                                    Tab content for Contact
                                </Tab>
                                <Tab eventKey="EasyLink" title={<span><img src={PartnersOnline} alt=''/>Generate Easy Link</span>}>
                                    
                                </Tab>
                                <Tab eventKey="ProcessandServices" title={<span><img src={PartnersOnline} alt=''/>Process and Services</span>}>
                                    Process and Services
                                </Tab>
                                <Tab eventKey="Co-BrandedCollaterals" title={<span><img src={PartnersOnline} alt='partner-online'/>Co-Branded Collaterals</span>}>
                                   Co-Branded Collaterals
                                </Tab>
                            </Tabs>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    )
}

export default TabsPartner